import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Terjadi kesalahan";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;

export const fileUrl = (p) =>
  p ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${p}` : "";

export async function uploadFile(file, kind = "uploads") {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  const r = await api.post("/files/upload", fd);
  return r.data;
}
